import { MenuSectionType } from '@/shared/data/MenuDefaults';
import {
    createContext, ReactNode, useState, Dispatch, SetStateAction, FC,
} from 'react';

type HeaderContextProps = {
    menuSection : MenuSectionType | null;
    dispatchMenuSection : Dispatch<SetStateAction<MenuSectionType | null>>;
    showMobileMenu : boolean;
    setShowMobileMenu : Dispatch<SetStateAction<boolean>>;
};
export const HeaderContext = createContext({} as HeaderContextProps);

type HeaderContextProviderProps = {
    children : ReactNode;
};

export const HeaderContextProvider : FC<HeaderContextProviderProps> = ({ children }) => {
    const [menuSection, dispatchMenuSection] = useState<MenuSectionType | null>(null);
    const [showMobileMenu, setShowMobileMenu] = useState<boolean>(false);

    return (
        <HeaderContext.Provider value={{ menuSection, dispatchMenuSection, showMobileMenu, setShowMobileMenu }}>
            {children}
        </HeaderContext.Provider>
    );
};
